import T from '../../services/language';
import {Container, ContainerView, ContainerViewFooter} from "../../components/Container";
import {Header} from "../../components/Header";
import Step from "../../components/Step";
import {NextButton, PackageButton, Packages} from "../../components/Button";
import {useEffect, useRef, useState} from "react";
import {
    DateView,
    EmailInput,
    FormPlaceholderLoading,
    ImagesSampleView,
    ImageUploadView,
    InputView,
    MultiSelect,
    PhoneInput,
    QuestionBody,
    QuestionHead,
    QuestionHeadContent,
    QuestionHeadIndex,
    QuestionHeadIndexRequire,
    QuestionView,
    SearchSelect
} from "./style";
import {Form, message} from "antd";
import {useApp} from "../../contexts/app";
import {useNavigate, useParams} from "react-router-dom";
import {
    cleanEmail,
    getAnswers,
    getAnswersLocal,
    getQuestions,
    postAnswers,
    setAnswersLocal,
    wrapAnswersRemoteAndLocal
} from "../../services/app";
import {cloneDeep, isEqual, sortBy} from "lodash";
import {ChooseTimeItem} from "../Booking/style";
import produce from "immer";
import {PlaceholderLoadingContainer} from "../../components/Loading/placeholder";
import useSessionCompleted from "../../hooks/completed";
import AnonymousChatPopup from "../AnonymoysChat/popup";

export default function Question() {
    const [rows, setRows] = useState([]);
    const [answer, setAnswer] = useState<any>({});
    const [ready, setReady] = useState(false);
    const [imagesUploading, setImageUploading] = useState([]);
    const [errors, setErrors] = useState<any>({});
    const [loading, setLoading] = useState(false);
    const {addAnswered, getAnswered, getLocalProductService, clientCode} = useApp();
    const navigate = useNavigate();
    let {
        campaignPath,
        campaignId,
        customerId,
        productServiceId,
        productServiceType,
        quantity,
        packageIndex, postalCode, locationType, productServiceTemplateId
    }: any = useParams();
    packageIndex = parseInt(packageIndex);
    quantity = parseInt(quantity);
    const sessionCompleted = useSessionCompleted();


    useEffect(() => {
        loadData();
    }, [packageIndex])

    const loadData = async () => {
        setReady(false);
        onScrollPackage();
        let resultRemoteQuestions;
        let resultRemoteAnswers;
        const taskQuestion = getQuestions(campaignId).then(res => resultRemoteQuestions = res);
        const taskAnswer = getAnswers(customerId, packageIndex + 1).then(res => resultRemoteAnswers = res);
        await Promise.all([taskQuestion, taskAnswer]);

        // merge remote questions template and questions items
        const itemQuestions = [
            ...(resultRemoteQuestions?.data?.data?.templateItems || []).sort((a, b) => {
                return a.index > b.index ? 1 : (a.index < b.index ? -1 : 0)
            }),
            ...(resultRemoteQuestions?.data?.data?.items || []).sort((a, b) => {
                return a.index > b.index ? 1 : (a.index < b.index ? -1 : 0)
            })
        ];


        let itemAnswers = (resultRemoteAnswers?.data?.data?.items || []).filter(item => item.packageIndex === (packageIndex + 1));
        const itemLocalAnswers = getAnswersLocal(customerId, packageIndex + 1);
        itemAnswers = wrapAnswersRemoteAndLocal(itemAnswers, itemLocalAnswers, itemQuestions);

        // load prev answer and set "email or phone" to current answer (if current answer is empty)
        let itemPrevPackageAnswers: any = [];
        const canLoadPrev = packageIndex > 0 && !!itemQuestions.find(x => (x.type === 'phone' || x.type === 'email')) && !itemAnswers.length;
        if (canLoadPrev) {
            const resultPrevRemoteAnswers = await getAnswers(customerId, packageIndex);
            itemPrevPackageAnswers = (resultPrevRemoteAnswers?.data?.data?.items || []).filter(item => item.packageIndex === packageIndex);
            const itemPrevLocalAnswersPrevLocal = getAnswersLocal(customerId, packageIndex);
            itemPrevPackageAnswers = wrapAnswersRemoteAndLocal(itemPrevPackageAnswers, itemPrevLocalAnswersPrevLocal, itemQuestions);
        }

        // set answer to question
        const result = itemQuestions.map(question => {
            let answer = itemAnswers.find(y => y.questionId === question.id);
            // set prev value
            if (!answer?.answer && canLoadPrev) {
                const answerPrevPackage = itemPrevPackageAnswers.find(y => y.questionId === question.id);
                if (["email", "phone"].includes(question.type) && answerPrevPackage?.answer) {
                    answer = answer || {};
                    answer.answer = answerPrevPackage?.answer;
                }
            }
            return {
                ...question,
                answer: {
                    questionId: question.id,
                    questionVersion: question.version,
                    questionType: question.type,
                    answer: answer?.answer || undefined,
                    options: answer?.options || undefined,
                    imageUrls: answer?.imageUrls || [],

                    isTemplate: question?.isTemplate || undefined,
                    pssGroupId: question?.pssGroupId || undefined,
                    campaignId: question?.campaignId || undefined,
                    key: question?.key || undefined,
                },
            }
        });

        setRows(result);
        setReady(true);
    }

    const onSave = async () => {
        const currentRows = cloneDeep(rows);
        ///// Check required question
        const emptyAnswerQuestionIds = currentRows.filter(x => {
            const canAnswer = x.isRequire && x.type !== 'statement' && x.showToCustomer;
            const hasAnswer = (!!x?.answer?.answer || !!x?.answer?.options?.length);
            return canAnswer && !hasAnswer;
        }).map(x => x.id);

        if (emptyAnswerQuestionIds?.length) {
            message.error(T("Please answer all required questions"));
            const elmQuestion = document.querySelector(`.question-${emptyAnswerQuestionIds[0]}`);
            if (elmQuestion) {
                elmQuestion.scrollIntoView({behavior: "smooth"});
            }
            return;
        }

        ///// Check required image
        const findNoneImage = currentRows?.filter(x => x.showToCustomer)?.find((x, i) => x.requireImages === 'yes' && !x?.answer?.imageUrls?.length);
        if (!!findNoneImage) {
            setErrors(produce(draft => {
                draft[findNoneImage?.id] = {
                    imageUrls: Date.now()
                }
            }));
            // message.error(T("Please upload image!"));
            window.document.querySelector(`.question-${findNoneImage?.id}`)?.scrollIntoView?.({behavior: 'smooth'})
            return;
        }

        const params: {
            contents: any[],
            campaignId: string,
            customerId: string,
            packageIndex: number,
        } = {
            contents: [],
            campaignId: campaignId,
            customerId: customerId,
            packageIndex: packageIndex + 1,
        };
        // filter only answered question
        params.contents = currentRows.filter(x => {
            return (!!x?.answer?.answer || !!x?.answer?.options?.length || (x.type === 'statement' && !!x?.answer?.imageUrls?.length))
        }).map(x => {
            if (x.answer) {
                // set question version to answer
                x.answer.questionVersion = x.questionVersion;
                // Clean image token urls
                if (x.answer.imageUrls?.length) {
                    x.answer.imageUrls = x.answer.imageUrls.map(y => {
                        return y.split("?")[0]
                    })
                }
            }
            return x?.answer;
        }).filter(x => !!x);
        setLoading(true);

        setAnswersLocal(customerId, packageIndex + 1, params.contents);

        const result = await postAnswers(params);

        addAnswered({...params, packageIndex});
        setLoading(false);
        if (result.status !== 200) {
            loadData().then();
        }
        return result;
    }

    const onNext = async () => {
        let result;

        if (!!rows.length) {
            result = await onSave();
        } else {
            result = {
                status: 200
            }
        }
        if (result?.status === 200) {
            if (isEndPackage) {
                navigate(`/${clientCode}/${campaignPath}/${campaignId}/${customerId}/product-and-service/${productServiceType}/${productServiceId}/${productServiceTemplateId}/${quantity}/confirm/${locationType}/${0}/${postalCode || ""}`);
            } else {
                goPackageIndex(packageIndex + 1);
            }
        } else {
            if (result?.data?.message) {
                message.error(result?.data?.message || "");
            }
        }
        setLoading(false);
    }

    const goPackageIndex = (index) => {
        navigate(`/${clientCode}/${campaignPath}/${campaignId}/${customerId}/product-and-service/${productServiceType}/${productServiceId}/${productServiceTemplateId}/${quantity}/question/${locationType}/${index}/${postalCode || ""}`);
    }

    const onScrollPackage = () => {
        document?.querySelector('.packages .active')?.scrollIntoView({
            behavior: "smooth",
            block: "end",
            inline: "end"
        });
    }

    const onChangeValue = (question, value, fieldName = "answer") => {
        const index = rows.findIndex(x => x.id === question.id);
        setRows(produce(draft => {
            draft[index].answer[fieldName] = value;
        }));
    }

    const isEndPackage = ((packageIndex + 1) === quantity);
    const isAnswered = !!answer?.id;
    const isOnlineMode = locationType === 'online';
    const isOnsiteMode = locationType === 'onsite';
    const isMyLocationMode = locationType === 'my-location';

    return (
        <>
        <Container>
            <Header title={T("Questionnaire")} back right={(
                <Step ignores={isOnlineMode ? [T("Location")] : []} current={isOnlineMode ? 2 : 3} dotStyle/>)}/>

            <ContainerView style={(quantity > 1) ? {} : {paddingTop: 1}}>
                {
                    quantity > 1 ? (
                        <Packages className={"packages"}>
                            {
                                [...Array(parseInt(quantity)).keys()].map((value, index) => {
                                    const hasQuestion = !!getAnswered(index);
                                    // next can answer
                                    const isNext = index > 0 && !!getAnswered(index - 1);
                                    //
                                    const service = getLocalProductService(productServiceId);
                                    return (
                                        <PackageButton
                                            onClick={() => {
                                                if (hasQuestion || isNext) {
                                                    goPackageIndex(index);
                                                    onScrollPackage();
                                                }
                                            }}
                                            className={`${(isNext || hasQuestion) ? 'has-value' : ''} ${index.toString() === packageIndex.toString() ? 'active' : ""}`}
                                            key={index.toString()}><span>{service?.name} ({value + 1})</span></PackageButton>
                                    )
                                })
                            }
                        </Packages>
                    ) : null
                }


                {
                    ready ? (
                        <>
                            {
                                rows.filter(x => x.showToCustomer).map((item, index) => {
                                    return (
                                        <QuestionView className={`question-${item.id}`}
                                                      key={index.toString()}>
                                            <QuestionHead>
                                                <QuestionHeadIndex>
                                                    {index + 1}
                                                    {!!item?.isRequire ? (<QuestionHeadIndexRequire/>) : null}
                                                </QuestionHeadIndex>
                                                <QuestionHeadContent>{item?.content || ""}</QuestionHeadContent>
                                            </QuestionHead>
                                            <QuestionBody>
                                                {
                                                    !!item?.sampleImages?.length ? (
                                                        <ImagesSampleView value={item?.sampleImages || []}/>
                                                    ) : null
                                                }
                                                {
                                                    item.type === 'statement' ? null : null
                                                }
                                                {
                                                    item.type === 'free-text' ? (
                                                        <Form.Item>
                                                            <InputView
                                                                onChange={e => {
                                                                    let value = e.target.value;
                                                                    if (item?.isIdentifier) {
                                                                        value = (value || "").replace(/^\s+|\s+$|\s/g, "");
                                                                    }
                                                                    onChangeValue(item, value, "answer");
                                                                }}
                                                                value={item?.answer?.answer}
                                                                autoSize={{minRows: 1, maxRows: 6}}></InputView>
                                                        </Form.Item>
                                                    ) : null
                                                }
                                                {
                                                    item.type === 'multiple-selection' ? (
                                                        <Form.Item>
                                                            <MultiSelect
                                                                onChange={e => {
                                                                    onChangeValue(item, e, "options");
                                                                }}
                                                                value={item?.answer?.options || []}
                                                                type={'multi'}
                                                                options={item?.options || []}
                                                            ></MultiSelect>
                                                        </Form.Item>
                                                    ) : null
                                                }
                                                {
                                                    item.type === 'single-selection' ? (
                                                        <Form.Item>
                                                            <MultiSelect
                                                                onChange={e => {
                                                                    onChangeValue(item, e, "options");
                                                                }}
                                                                value={item?.answer?.options || []}
                                                                type={'single'}
                                                                options={item?.options || []}
                                                            ></MultiSelect>
                                                        </Form.Item>
                                                    ) : null
                                                }
                                                {
                                                    item.type === 'search-selection' ? (
                                                        <Form.Item>
                                                            <SearchSelect
                                                                onChange={e => {
                                                                    const value = e?.map(item => ({
                                                                        key: item?.key,
                                                                        value: item?.value
                                                                    }))
                                                                    onChangeValue(item, value, "options");
                                                                }}
                                                                value={item?.answer?.options || []}
                                                                options={item?.options || []}
                                                            ></SearchSelect>
                                                        </Form.Item>
                                                    ) : null
                                                }
                                                {
                                                    item.type === 'date' ? (
                                                        <Form.Item>
                                                            <DateView
                                                                onChange={e => {
                                                                    onChangeValue(item, e, "answer");
                                                                }}
                                                                value={item?.answer?.answer}
                                                            />
                                                        </Form.Item>
                                                    ) : null
                                                }
                                                {
                                                    item.type === 'email' ? (
                                                        <Form.Item>
                                                            <EmailInput
                                                                onChange={e => {
                                                                    const value = cleanEmail(e.target.value);
                                                                    onChangeValue(item, value, "answer");
                                                                }}
                                                                value={item?.answer?.answer || ""}
                                                            />
                                                        </Form.Item>
                                                    ) : null
                                                }

                                                {
                                                    item.type === 'phone' ? (
                                                        <Form.Item>
                                                            <PhoneInput
                                                                onChange={e => {
                                                                    const value = e;
                                                                    onChangeValue(item, value, "answer");
                                                                }}
                                                                value={item?.answer?.answer || ""}
                                                                countryCallingCode={(item?.phoneCountryCode || "").replace('+', '')}/>
                                                        </Form.Item>
                                                    ) : null
                                                }

                                                {
                                                    !!item.requireImages && item.requireImages !== 'no' ? (
                                                        <Form.Item style={{marginTop: -9}}>
                                                            <ImageUploadView
                                                                value={item?.answer?.imageUrls || []}
                                                                onChange={e => {
                                                                    const value = e;
                                                                    if (value?.length && item.type !== 'statement') {
                                                                        if (!item?.answer?.answer && !item?.answer?.options?.length) {
                                                                            message.error(T("Please answer the question first"));
                                                                            return null;
                                                                        }
                                                                    }
                                                                    onChangeValue(item, value, "imageUrls");
                                                                }}
                                                                onUploading={(event => {
                                                                    if (event) {
                                                                        setImageUploading(produce(draft => {
                                                                            draft.push(index);
                                                                        }))
                                                                    } else {
                                                                        setImageUploading(produce(draft => {
                                                                            return draft.filter(x => x !== index);
                                                                        }))
                                                                    }
                                                                })}
                                                                index={packageIndex}
                                                                error={errors[item?.id]?.imageUrls}
                                                                required={item.requireImages === 'yes'}/>
                                                        </Form.Item>
                                                    ) : null
                                                }

                                            </QuestionBody>
                                        </QuestionView>
                                    )
                                })
                            }
                            {
                                !rows?.length ? (
                                    <ChooseTimeItem
                                        style={{width: '100%', marginTop: 32}}>{T('No Questions')}</ChooseTimeItem>
                                ) : null
                            }
                        </>
                    ) : (
                        <PlaceholderLoadingContainer>
                            <FormPlaceholderLoading style={{marginTop: 24}}/>
                            <FormPlaceholderLoading/>
                            <FormPlaceholderLoading/>
                            <FormPlaceholderLoading/>
                            <FormPlaceholderLoading/>
                        </PlaceholderLoadingContainer>
                    )
                }

                <ContainerViewFooter>
                    <NextButton loading={loading} disabled={!!imagesUploading.length || !ready}
                                onClick={onNext}>{T('Next')}</NextButton>
                </ContainerViewFooter>
            </ContainerView>
        </Container>
        <AnonymousChatPopup/>
        </>
    );
}
